import { getUserInfo } from '@/utils/user'
import axios from 'axios'
import { Notification, MessageBox } from 'element-ui'
import { getToken } from './cookies'
import { HttpInstance, HttpRequestConfig, ContentType } from './request.interface'
import env from './env'
import i18n from '@/lang'

const createEnv = () => {
  return /test|develop|localhost/.test(window.location.hostname) ? env.dev : env.prod
}

const service: HttpInstance = axios.create({
  baseURL: createEnv().baseAPI,
  timeout: 50 * 1000,
  withCredentials: true,
  headers: {
    'Content-Type': ContentType.JSON
  }
})

// Request interceptors
service.interceptors.request.use(
  (config: HttpRequestConfig) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    const token = getToken()
    if (token) {
      config.headers.token = token
    }

    const tenantId = getUserInfo('tenantId')
    const { userNo, mid } = getUserInfo('userInfoMap') || {}
    if (config.headers['Content-Type'] === ContentType.FORM_DATA) {
      //
    } else {
      config.data = { ...config.data, tenantId: Number(tenantId), userNo, mid }
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  response => {
    const res = response.data
    if (!res.code) {
      res.code = ''
      return res
    }
    if (res.code !== '200' && res.code !== '0') {
      if (res.code === '600928') {
        MessageBox.confirm(i18n.t('You have been logged out, try to login again.') as string, i18n.t('Log out') as string, {
          confirmButtonText: i18n.t('Relogin') as string,
          cancelButtonText: i18n.t('Cancel') as string,
          type: 'warning'
        }).then(() => {
          location.href = '/login'
        })
        return
      }
      if (response.config.disableError) {
        return res
      }
      Notification.error({ title: 'Error', message: res.msg })
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res.data
    }
  },
  error => {
    Notification.error({ title: 'Error', message: error.message })
    return Promise.reject(error)
  }
)

export default service
